"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONBorderInfoConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var border_info_1 = require("../../borders/border-info");
var json_general_enums_1 = require("../enums/json-general-enums");
var json_color_model_info_converter_1 = require("./json-color-model-info-converter");
var JSONBorderInfoConverter = (function () {
    function JSONBorderInfoConverter() {
    }
    JSONBorderInfoConverter.convertFromJSON = function (obj, colorModelInfoCache) {
        var result = new border_info_1.BorderInfo();
        result.style = obj[json_general_enums_1.JSONBorderBaseProperty.Style];
        result.color = colorModelInfoCache.getItemByJsonKey(obj[json_general_enums_1.JSONBorderBaseProperty.ColorIndex]);
        if (!result.color)
            result.color = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertFromJSON(obj[json_general_enums_1.JSONBorderBaseProperty.Color]);
        result.width = obj[json_general_enums_1.JSONBorderBaseProperty.Width];
        result.offset = obj[json_general_enums_1.JSONBorderBaseProperty.Offset];
        result.frame = !!obj[json_general_enums_1.JSONBorderBaseProperty.Frame];
        result.shadow = !!obj[json_general_enums_1.JSONBorderBaseProperty.Shadow];
        return result;
    };
    JSONBorderInfoConverter.convertToJSON = function (source) {
        var result = {};
        result[json_general_enums_1.JSONBorderBaseProperty.Style] = source.style;
        result[json_general_enums_1.JSONBorderBaseProperty.Color] = json_color_model_info_converter_1.JSONColorModelInfoConverter.convertToJSON(source.color);
        result[json_general_enums_1.JSONBorderBaseProperty.Width] = source.width;
        result[json_general_enums_1.JSONBorderBaseProperty.Offset] = source.offset;
        result[json_general_enums_1.JSONBorderBaseProperty.Frame] = common_1.boolToInt(source.frame);
        result[json_general_enums_1.JSONBorderBaseProperty.Shadow] = common_1.boolToInt(source.shadow);
        return result;
    };
    return JSONBorderInfoConverter;
}());
exports.JSONBorderInfoConverter = JSONBorderInfoConverter;
